"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.86 4.4a1.3 1.3 0 0 0-1.3 1.3v13.504l.898-.466a1.7 1.7 0 0 1 1.565 0l1.597.828 1.598-.828a1.7 1.7 0 0 1 1.564 0l1.598.827 1.597-.828a1.7 1.7 0 0 1 1.565 0l.898.466V5.7a1.3 1.3 0 0 0-1.3-1.3zm-2.7 1.3A2.7 2.7 0 0 1 6.86 3h10.28a2.7 2.7 0 0 1 2.7 2.7v13.906c0 .828-.87 1.448-1.668 1.035l-1.274-.661a.3.3 0 0 0-.277 0l-1.72.892H14.9a1.13 1.13 0 0 1-1.04 0l-1.72-.891a.3.3 0 0 0-.277 0l-1.72.892h-.002a1.13 1.13 0 0 1-1.04 0h-.002l-1.72-.892a.3.3 0 0 0-.276 0l-1.273.66-.003.002c-.797.41-1.666-.209-1.666-1.037z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.769 7.06a.7.7 0 0 1 .7.7v.176c.538.118.955.374 1.253.713.396.45.532.987.532 1.375a.7.7 0 1 1-1.4 0 .74.74 0 0 0-.183-.45c-.118-.134-.363-.31-.902-.31-.452 0-.72.134-.866.269a.66.66 0 0 0-.22.491c0 .145.044.273.226.443.209.196.567.41 1.147.672.595.267 1.134.541 1.522.894.43.39.676.878.676 1.496 0 .656-.287 1.219-.763 1.604a2.5 2.5 0 0 1-1.022.48v.18a.7.7 0 1 1-1.4 0v-.188c-1.136-.287-1.785-1.25-1.785-2.076a.7.7 0 1 1 1.4 0c0 .186.27.76 1.085.76.393 0 .674-.11.842-.245a.63.63 0 0 0 .243-.515c0-.188-.052-.31-.217-.46-.207-.188-.56-.386-1.156-.654-.61-.274-1.144-.565-1.53-.927-.413-.387-.667-.868-.667-1.464 0-.56.227-1.115.673-1.524a2.4 2.4 0 0 1 1.112-.562v-.177a.7.7 0 0 1 .7-.7m3.762 1.592a.7.7 0 0 1 .7-.7h1.785a.7.7 0 1 1 0 1.4h-1.785a.7.7 0 0 1-.7-.7m0 3.124a.7.7 0 0 1 .7-.7h1.785a.7.7 0 1 1 0 1.4h-1.785a.7.7 0 0 1-.7-.7m0 3.123a.7.7 0 0 1 .7-.7h1.785a.7.7 0 1 1 0 1.4h-1.785a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ReceiptIcon24.js.map